import { render, staticRenderFns } from "./BundleCheckbox.vue?vue&type=template&id=8f0c4084"
import script from "./BundleCheckbox.vue?vue&type=script&lang=ts"
export * from "./BundleCheckbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports